import axios from '@/axios/api.request'

export const save = (form) => axios.request({
    url: '/setting/reward/info/save',
    data: form,
    method: 'post'
  })

export const remove = (id) => axios.request({
    url: `/setting/reward/info/delete/${id}`,
    method: 'delete'
  })